import { Box, customStyled } from '@mafc/trolly';

const CardContainer = customStyled(Box)`
    border-radius: 12px;
`;

export default CardContainer;
